import { render, staticRenderFns } from "./InterventionPlanObjetives.vue?vue&type=template&id=4dd434ca&scoped=true"
import script from "./InterventionPlanObjetives.vue?vue&type=script&lang=js"
export * from "./InterventionPlanObjetives.vue?vue&type=script&lang=js"
import style0 from "./InterventionPlanObjetives.vue?vue&type=style&index=0&id=4dd434ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd434ca",
  null
  
)

export default component.exports